import dayjs from 'dayjs';

const EM_DASH = '—';

/** Ant Design DatePicker display format (DOC-013A). */
export const DOCUMENT_UI_DATE_FORMAT = 'DD.MM.YYYY';

/** Ant Design DatePicker with time. */
export const DOCUMENT_UI_DATETIME_FORMAT = 'DD.MM.YYYY HH:mm';

export function formatDocumentUiDate(value: string | null | undefined): string {
  if (value == null || String(value).trim() === '') return EM_DASH;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(DOCUMENT_UI_DATE_FORMAT) : EM_DASH;
}

export function formatDocumentUiDateTime(value: string | null | undefined): string {
  if (value == null || String(value).trim() === '') return EM_DASH;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(DOCUMENT_UI_DATETIME_FORMAT) : EM_DASH;
}

export function formatDocumentUiTime(value: string | null | undefined): string {
  if (value == null || String(value).trim() === '') return EM_DASH;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('HH:mm:ss') : EM_DASH;
}
